import { combineReducers } from 'redux';
import * as actions from '../actions';
import { Reducer } from '../../../types';

export type UxState = {
  hoveredRow: number;
};

type UxActions = ReturnType<ValueOf<typeof actions>>;
type ReducerOf<T extends keyof UxState> = Reducer<UxState, UxActions, T>;

const hoveredRow: ReducerOf<'hoveredRow'> = (state: number = 0, action) => {
  switch (action.type) {
    case actions.setHoveredItemId.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<UxState>({
  hoveredRow,
});
